import state from './moduleEnterpriseVesselViewState.js'
import mutations from './moduleEnterpriseVesselViewMutations.js'
import actions from './moduleEnterpriseVesselViewActions.js'
import getters from './moduleEnterpriseVesselViewGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
